function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from "react";
import { connect } from "react-redux";
import { closeModal, openModal } from "@common/actions";
import Channels from "@common/components/ChannelsModal";
import FrequentlyAskedQuestions from "@common/components/FrequentlyAskedQuestions";
import LimitModal from "@common/components/LimitModal";
import Policy from "@common/components/Policies";
import PrivacyPolicy from "@common/components/PrivacyPolicy";
import Settings from "@common/components/Settings";
import TermsAndConditionsModal from "@common/components/TermsAndConditionsModal";
import VODModal from "@common/components/VODModal";
import MessageModule from "@common/components/account/MessageModule";
import PostLoginMultiModal from "@common/components/authentication/PostLoginMultiModal";
import GuidePage from "@common/containers/GuidePage";
import Account from "@common/containers/Account";
import BoxSpecification from "@common/containers/BoxSpecification";
import { LIMIT, VOD_MODAL } from "@common/constants";
import { isMobile } from "@common/services/helpers";
import { ACCOUNT, BOX_SPECIFICATION, CHANNELS, COOKIE_POLICY, FREQUENTLY_ASKED_QUESTIONS, INSTALLATION_GUIDE, KEY_ESCAPE, MESSAGE_MODULE, MISSING_INFO, PRIVACY_POLICY, SETTINGS, TERMS_AND_CONDITIONS } from "@config/constants";
var ModalConductor = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ModalConductor, Component);
    var _super = _create_super(ModalConductor);
    function ModalConductor(props) {
        _class_call_check(this, ModalConductor);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "handleClose", function() {
            var _modalData_modalProps;
            var _this_props = _this.props, _$closeModal = _this_props.closeModal, modalData = _this_props.modalData;
            var onClose = (_modalData_modalProps = modalData.modalProps) === null || _modalData_modalProps === void 0 ? void 0 : _modalData_modalProps.onClose;
            _$closeModal();
            onClose && onClose();
        });
        _this.wrapperRef = null;
        _this.handleClickOutside = _this.handleClickOutside.bind(_assert_this_initialized(_this));
        _this.closeFromKeyboard = _this.closeFromKeyboard.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(ModalConductor, [
        {
            /**
     * Closes the modal on escape keydown
     * @param {Object} event
     */ key: "closeFromKeyboard",
            value: function closeFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_ESCAPE) {
                    this.handleClose();
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (isMobile.any()) {
                    window.scrollTo(0, 1);
                }
                document.addEventListener("mousedown", this.handleClickOutside);
                document.addEventListener("keydown", this.closeFromKeyboard);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("mousedown", this.handleClickOutside);
                document.removeEventListener("keydown", this.closeFromKeyboard);
            }
        },
        {
            /**
     * Finds an ancestor of an element with certain class
     * @param el {Element}
     * @param cls {string}
     */ key: "findAncestor",
            value: function findAncestor(el, cls) {
                while(el){
                    if (el.classList.contains(cls)) {
                        return el;
                    }
                    el = el.parentElement;
                }
                return null;
            }
        },
        {
            /**
     * Closes the modal on click outside of the modal wrapper
     * @param {Object} event
     */ key: "handleClickOutside",
            value: function handleClickOutside(event) {
                if (this.wrapperRef && this.wrapperRef === event.target) {
                    // here we are checking if the clicked element is part of material UI Menu component
                    // because it is rendered outside of the Modal wrapper and thus triggering close of modal
                    var modalMenu = this.findAncestor(event.target, "menu-internal");
                    var muiCountriesDropdown = document.getElementById("menu-country");
                    var writeToUsModal = this.findAncestor(event.target, "write-to-us-overlay");
                    var gdprModal = this.findAncestor(event.target, "gdpr-overlay");
                    var confirmationModal = this.findAncestor(event.target, "confirmation-overlay");
                    var promotionsModal = this.findAncestor(event.target, "promotions-overlay");
                    var snackbar = this.findAncestor(event.target, "snackbar");
                    if (!modalMenu && !writeToUsModal && !gdprModal && !muiCountriesDropdown && !promotionsModal && !confirmationModal && !snackbar) {
                        this.handleClose();
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var modalData = this.props.modalData;
                var _obj;
                var MODAL_MAP = (_obj = {}, _define_property(_obj, MESSAGE_MODULE, {
                    component: MessageModule
                }), _define_property(_obj, MISSING_INFO, {
                    component: PostLoginMultiModal
                }), _define_property(_obj, FREQUENTLY_ASKED_QUESTIONS, {
                    component: FrequentlyAskedQuestions
                }), _define_property(_obj, ACCOUNT, {
                    component: Account
                }), _define_property(_obj, BOX_SPECIFICATION, {
                    component: BoxSpecification
                }), _define_property(_obj, PRIVACY_POLICY, {
                    component: PrivacyPolicy
                }), _define_property(_obj, COOKIE_POLICY, {
                    component: Policy
                }), _define_property(_obj, TERMS_AND_CONDITIONS, {
                    component: TermsAndConditionsModal
                }), _define_property(_obj, INSTALLATION_GUIDE, {
                    component: GuidePage
                }), _define_property(_obj, CHANNELS, {
                    component: Channels
                }), _define_property(_obj, SETTINGS, {
                    component: Settings
                }), _define_property(_obj, LIMIT, {
                    component: LimitModal
                }), _define_property(_obj, VOD_MODAL, {
                    component: VODModal
                }), _obj);
                if (!modalData.isModalOpened) {
                    return null;
                }
                // const SpecificModal = MODAL_MAP[modalData.modalName].component;
                return /*#__PURE__*/ _jsx("div", {
                    className: "modal-overlay",
                    ref: function(node) {
                        return _this.wrapperRef = node;
                    },
                    children: modalData.modals.map(function(param) {
                        var modalName = param.modalName, modalProps = param.modalProps;
                        var SpecificModal = MODAL_MAP[modalName].component;
                        return /*#__PURE__*/ _jsx(SpecificModal, _object_spread({}, modalProps), modalName);
                    })
                });
            }
        }
    ]);
    return ModalConductor;
}(Component);
var mapStateToProps = function(param) {
    var modal = param.modal;
    return {
        modal: modal
    };
};
export default connect(mapStateToProps, {
    closeModal: closeModal,
    openModal: openModal
})(ModalConductor);
